import { generateActions, generateSelectors, generateTypes } from "../util";

export const key = "users";

// create user
export const CREATE_USER = generateTypes(key, "create");
export const [createUser, createUserSuccess, createUserError, createUserBusy] = generateActions(CREATE_USER);
export const [selectCreateUser, selectCreateUserError, selectCreateUserBusy, , selectCreateUserRequest] =
  generateSelectors(CREATE_USER);
